import React from "react";
import ReactDOM from "react-dom";
import "../modal.css";

const DeleteSkuConfirmation = ({ message, onConfirm, onCancel }) => {
  return ReactDOM.createPortal(
    <>
      <div className="custom-modal-backdrop" onClick={onCancel}></div>
      <div className="custom-modal w-[40%]">
        <div className="custom-modal-content">
          <div className="custom-modal-header">
            <h5 className="custom-modal-title">Confirmation</h5>
            <button className="custom-close-btn" onClick={onCancel}>&times;</button>
          </div>
          <div className="custom-modal-body text-center p-4">
            <p className="text-lg">Are you sure you want to delete this SKU?</p>
          </div>
          <div className="custom-modal-footer flex justify-center gap-4 p-4">
            <button className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-1 shadow-xs ring-gray-300 ring-inset hover:bg-gray-50 sm:mt-0 sm:w-auto" onClick={onCancel}>
              Cancel
            </button>
            <button className="inline-flex w-full justify-center rounded-md bg-emerald-600 px-5 py-2 text-sm font-semibold text-white shadow-xs hover:bg-emerald-500 sm:ml-3 sm:w-auto" onClick={onConfirm}>
              OK
            </button>
          </div>
        </div>
      </div>
    </>,
    document.getElementById("popup-root")
  );
};

export default DeleteSkuConfirmation;
